import React, { useEffect, useState } from "react";
import "./SampleQuestions.scss";
import { Bullets, CheckboxRadio, SkeletonList } from "ui-components";
import { useTranslation } from "react-i18next";
import BackArrow from "../../../utils/Images/BackArrow";
// import ComingSoon from "../../../components/ComingSoon/ComingSoon";
import { getSessionStorageItem } from "../../../utils/SessionStorageMethod/getSessionStorageItem";
import { getSampleQuestion } from "../../../service/Scope/Scope";
const SampleQuestions: React.FC = () => {
  const { t } = useTranslation();
  const [sampleData, setSampleData] = useState<any>([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    window.scrollTo(0, 0);
  });
  const ownPreview = getSessionStorageItem("ownPreview") || [];
  // get Sample questions api
  const getSampleQuestionsApi = async () => {
    // Extract the skillId, difficultyLevel, totalQuestions and questionType from ownPreview array and make seperate array to pass in sample questions api.
    const assessmentSkills = ownPreview.flatMap((skill: any) =>
      Object.entries(skill.selectedDifficultyLevels).map(
        ([difficultyLevel, totalQuestions]) => ({
          skillId: skill.skillId,
          difficultyLevel,
          totalQuestions,
          questionType: skill.questionType,
        }),
      ),
    );
    try {
      const res = await getSampleQuestion(assessmentSkills);
      if (res?.status === 200) {
        let questionCounter = 1;
        const transformedData = res?.data.reduce((acc: any, item: any) => {
          const categoryIndex = acc.findIndex(
            (category: any) => category.category === item.categoryName,
          );
          const question = {
            id: item.skillId,
            type: item.questionType,
            time: `${item.timeLimit} min`,
            technology: `${item.skillName} - ${item.difficultyLevel}`,
            questionText: item.question.question,
            options:
              Array.isArray(item.answerOptions) && item.answerOptions.length > 0
                ? item.answerOptions.map((option: any) => ({
                    text: option.option,
                    isDefault: false,
                  }))
                : [],
            questionNo: questionCounter++,
          };
          if (categoryIndex > -1) {
            acc[categoryIndex].questions.push(question);
          } else {
            acc.push({
              category: item.categoryName,
              questions: [question],
            });
          }
          return acc;
        }, []);
        setSampleData(transformedData);
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getSampleQuestionsApi();
  }, []);
  return (
    <div className="sample-questions">
      <div className="sample-header">
        <div className="backArrow" onClick={() => window.history.back()}>
          <BackArrow />
        </div>
        <span>{t("GENERAL.SAMPLE_QUEST")}</span>
      </div>
      {loading ? (
        <>
          {Array.from({ length: 5 }).map((_, index) => (
            <SkeletonList
              key={`skeleton-${index}`}
              numberOfTitles={1}
              numberofTextLines={5}
              titleSize={18}
              textSize={12}
              thumbnailHeight={250}
              thumbnailWidth={270}
              itemsGap={20}
            />
          ))}
        </>
      ) : sampleData && sampleData.length > 0 ? (
        sampleData.map((item: any, index: any) => (
          <div key={index} className="category-section">
            <h3>
              {t("GENERAL.CATEGORY")} : <span>{item?.category}</span>
            </h3>
            {item?.questions?.map((question: any) => (
              <div key={question?.id} className="question-card">
                <div className="question-header">
                  <Bullets skillName={question?.technology} />
                  <span className="question-info">
                    {t("GENERAL.TYPE")} : <span>{question?.type}</span> |{" "}
                    {t("GENERAL.TIME")} : <span>{question?.time}</span>
                  </span>
                </div>
                <span className="question-text">
                  <strong>Q. {question?.questionNo} </strong>
                  {question?.questionText}
                  {question?.options?.length ? <hr /> : null}
                </span>
                {/* Conditional rendering based on question type */}
                {question?.type === "Single" && (
                  <div className="question-options">
                    {question?.options?.map((option: any, idx: any) => (
                      <label key={idx} className="option-label">
                        <CheckboxRadio
                          name="ansOptions"
                          type="radio"
                          checked={option.isDefault}
                          additionalProps={{ disabled: option.isDefault }}
                        />
                        {option.text}
                      </label>
                    ))}
                  </div>
                )}
                {question?.type === "Multiple" && (
                  <div className="question-options">
                    {question?.options?.map((option: any, idx: any) => (
                      <label key={idx} className="option-label">
                        <CheckboxRadio
                          name="ansOptions"
                          type="checkbox"
                          checked={option.isDefault}
                          additionalProps={{ disabled: option.isDefault }}
                        />
                        {option.text}
                      </label>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        ))
      ) : (
        <div className="no-sample-questions">
          <span>{t("GENERAL.NO_SAMPLE_QUESTIONS_AVAILABLE")}</span>
        </div>
      )}
    </div>
  );
};

export default SampleQuestions;
